var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.1667L10.5 11.7167C10.175 11.6833 9.93333 11.6667 9.66667 11.6667C7.44167 11.6667 3 12.7833 3 15V16.6667H10.5L8 14.1667ZM9.66667 10C11.5083 10 13 8.50834 13 6.66667C13 4.825 11.5083 3.33334 9.66667 3.33334C7.825 3.33334 6.33333 4.825 6.33333 6.66667C6.33333 8.50834 7.825 10 9.66667 10Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3917 17.0833L10.5 14.1667L11.6667 12.9917L13.3917 14.725L17.6667 10.4167L18.8333 11.5917L13.3917 17.0833Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitor);
export default __webpack_public_path__ + "static/media/visitor.be67cea8d20080d2f92522935f4f283a.svg";
export { ForwardRef as ReactComponent };